import { Directive, HostListener, Optional } from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';

import { KEY_CODE } from '@summit/core';

@Directive({
  selector: '[summitForm]',
  standalone: true
})
export class SummitFormDirective {
  form?: FormGroupDirective | NgForm;

  constructor(
    @Optional() private formGroup?: FormGroupDirective,
    @Optional() private ngForm?: NgForm
  ) {
    this.form = this.formGroup ?? this.ngForm;
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    // console.log(event);

    if (event.keyCode === KEY_CODE.ENTER && event.ctrlKey === true) {
      this.submitForm();
    }
  }

  submitForm() {
    // console.log(`Submitting form`);
    this.form?.ngSubmit.emit();
  }
}
